import { useEffect, useState } from 'react';
import classNames from 'classnames';
import BaseInputErrors from '../../../../../../ui/layout/form/input/BaseInputErrors';
import { MultiSelectInputLayoutType } from 'framework/form';
import DefaultFilterInputLayout from '../DefaultFilterInputLayout';
import FilterActions from '../FilterActions';
import useDropDownFilterHelper from '../useDropDownFilterHelper';
import MultipleDropdownListLayout from './MultipleDropdownListLayout';
import MultipleDropdownSearchLayout from './MultipleDropdownSearchLayout';
import SearchIcon from '@mui/icons-material/SearchOutlined';
import { Box } from '@mui/material';

const MultipleDropdownFilterInputLayout: MultiSelectInputLayoutType = props => {
  const { label, errorMessages, onChangeCallback = () => {}, value: selectedValue = [], source } = props;
  const hasError = errorMessages && errorMessages.length > 0;
  const invalidClass = hasError ? 'is-invalid' : '';
  const [isLoading, setIsLoading] = useState(false);

  const { isMenuOpened, getDisplayedValue, toggleMenu } = useDropDownFilterHelper({ source });
  const displayedValue = getDisplayedValue(selectedValue || []);

  useEffect(() => {
    setIsLoading(false);
  }, [isMenuOpened]);

  return (
    <DefaultFilterInputLayout
      label={label}
      isOpen={isMenuOpened}
      toggleMenu={toggleMenu}
      displayedValue={displayedValue}
      source={source}
      className={classNames('multiselect-button-dropdown', invalidClass)}
    >
      <Box
        className="search-filter-control-wrapper"
        sx={theme => ({
          position: 'relative',
          minWidth: '275px',
          [theme.breakpoints.down('sm')]: { fontSize: '14px' },
          '& .button-dropdown__menu-item:nth-child(2)': { marginTop: '5px' },
          '& .button-dropdown__menu-item.isMessage': {
            borderTop: '1px solid',
            borderTopColor: 'border.default',
            borderBottom: '1px solid',
            borderBottomColor: 'border.default',
            fontSize: '12px',
            marginTop: '5px',
            marginBottom: '5px',
            backgroundColor: 'background.paper',
            cursor: 'default',
          },
          "& div[class$='-placeholder']": { color: 'text.secondary' },
        })}
      >
        <MultipleDropdownSearchLayout {...props} setIsLoading={setIsLoading} onChangeCallback={onChangeCallback} />

        {!isLoading && !!selectedValue?.length && (
          <>
            <MultipleDropdownListLayout selectedValues={selectedValue} onChangeCallback={onChangeCallback} />
            <BaseInputErrors errorMessages={errorMessages} />
            <Box sx={{ marginBottom: '4px' }}>
              <FilterActions onChangeCallback={toggleMenu} onResetCallback={toggleMenu} />
            </Box>
          </>
        )}

        <SearchIcon sx={{ position: 'absolute', top: '9px', left: '10px', fontSize: '22px' }} />
      </Box>
    </DefaultFilterInputLayout>
  );
};

export default MultipleDropdownFilterInputLayout;
